class Tabs {
  constructor() {
  }
  init() {
    const tabButtons = document.querySelectorAll('.subscriptions__tab');
    tabButtons.forEach(tab => {
      tab.addEventListener('click', e => {
        const activeTab = document.querySelector('.subscriptions__tab--selected');
        const clickedTab = e.target;
        this.switchTab(activeTab, clickedTab);
      })
    })
  }
  switchTab(activeTab, clickedTab) {
    const activeTabId = activeTab.getAttribute("data-tab-id");
    const clickedTabId = clickedTab.getAttribute("data-tab-id");

    const activeTabContent = document.getElementById(`tab-${activeTabId}`);
    const clickedTabContent = document.getElementById(`tab-${clickedTabId}`);

    activeTab.classList.remove('subscriptions__tab--selected')
    activeTabContent.classList.add('subscriptionTable__small--hide')

    clickedTab.classList.add('subscriptions__tab--selected')
    clickedTabContent.classList.remove('subscriptionTable__small--hide')

  }
}

export default new Tabs();